<template>
    <div class="page-home">
        <ButtonNavLink
            v-for="( route, index ) in permissibleLinks"
            :key="`${ route.meta.title }${ index }`"
            :route="route"
        />
    </div>
</template>

<script>
// Vuex
import { mapState, mapGetters } from 'vuex';

// Routes
import SettingsRoute from '@/router/routes/Settings';
import MailSearchRoute from '@/router/routes/Mail/routes/Search';
import MailReceiveRoute from '@/router/routes/Mail/routes/Receive';
import MailShelveRoute from '@/router/routes/Mail/routes/Shelve';
import MailPickUpRoute from '@/router/routes/Mail/routes/PickUp';
import MailDeliveryRoute from '@/router/routes/Mail/routes/Delivery';

// Components
import ButtonNavLink from './home/ButtonNavLink';

export default {
    name: 'Home',
    components: {
        ButtonNavLink,
    },
    data() {
        return {
            routeLinkList: [
                MailSearchRoute,
                MailReceiveRoute,
                MailShelveRoute,
                MailPickUpRoute,
                MailDeliveryRoute,
                SettingsRoute,
            ],
        };
    },
    computed: {
        ...mapState( {
            isLoggingIn: ( state ) => state.User.loginInFlight,
            isGettingPermissions: ( state ) => state.User.permissions.inFlight,
        } ),
        ...mapGetters( {
            actionsForCurrentLocation: 'User/actionsForCurrentLocation',
        } ),
        permissibleLinks() {
            return this.routeLinkList.filter( ( route ) => {
                if ( !route.meta.allowedActions ) return true;
                const allowedRouteActions = new Set( route.meta.allowedActions );
                return this.actionsForCurrentLocation.filter( ( myAction ) => allowedRouteActions.has( myAction ) ).length > 0;
            } );
        },
    },
};
</script>

<style scoped lang="scss">

.page-home {
    display: flex;
    flex-flow: column nowrap;
    height: 75%;

    >* {
        margin-bottom: .5rem;
    }
}

/* media queries */
@include mixins-above(tablet){
    //
}

@include mixins-above(desktop){
    .page-home {
        flex-flow: row wrap;

        >* {
            flex: 1 1 25%;
            margin: 2rem;
        }
    }
}
</style>
